var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 20,
    height: 20,
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,4.9c-0.8-2-2.3-3.4-4.3-4.3c-2-0.9-4.3-0.9-6.3,0c-2,0.9-3.4,2.3-4.3,4.3C0.2,5.8,0,6.9,0,8 c0,1.1,0.2,2.2,0.6,3.1c0.9,2,2.3,3.4,4.3,4.3c1,0.4,2,0.6,3.1,0.6c1.1,0,2.1-0.2,3.1-0.6c2-0.8,3.4-2.3,4.3-4.3 c0.4-1,0.6-2.1,0.6-3.1C16,6.9,15.8,5.9,15.4,4.9z M14.7,8c0,1.2-0.3,2.3-0.9,3.4c-0.6,1-1.4,1.8-2.5,2.4c-1,0.6-2.2,0.9-3.4,0.9 c-0.9,0-1.8-0.2-2.6-0.5c-0.8-0.4-1.6-0.8-2.1-1.4c-0.6-0.6-1.1-1.3-1.4-2.1C1.5,9.8,1.3,8.9,1.3,8c0-1.2,0.3-2.3,0.9-3.4 c0.6-1,1.4-1.8,2.4-2.4c1-0.6,2.1-0.9,3.4-0.9s2.3,0.3,3.4,0.9c1,0.6,1.9,1.4,2.5,2.4C14.4,5.7,14.7,6.8,14.7,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,7.8V3.5c0-0.4-0.3-0.7-0.7-0.7c-0.4,0-0.7,0.3-0.7,0.7V8l0,0.1c0,0.2,0,0.4,0.2,0.5l2.6,2.6 c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2c0.3-0.3,0.3-0.7,0-0.9L8.7,7.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.a105b44aeb8d6279c3fb871dfcde87c7.svg";
export { ForwardRef as ReactComponent };